<div class="profile-container">
    <div class="">
        <div class="profile-content">

            <div class="personal-details">

                <div class="header-block">
                    <div class="header-title">
                        <app-breadcrumb></app-breadcrumb>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <form autocomplete="off">
                                <input type="text" (keyup.enter)="getProductByWildSearch(0,10)"
                                    [ngModelOptions]="{standalone: true}" placeholder="search product"
                                    [(ngModel)]="searchKey">
                            </form>

                            <i class="bi bi-search" (click)="getProductByWildSearch(0,10)"></i>
                        </div>
                        <button data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{
                            'generic.add' | translate }}</button>
                        <!-- <button (click)="productMasterBulkUploadButtonClick()">Add Bulk</button> -->
                        <!-- <input type="file" id="bulkAdd" (change)="productMasterBulkUpload($event)" accept=".xls,.xlsx" [style.display]="'none'"> -->
                        <div class="filter-icon">
                            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                        </div>
                    </div>
                </div>

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 5%;">{{ 'product-master.productMasterId' | translate }}</th>
                            <th style="width: 20%;">{{ 'product-master.name' | translate }}</th>
                            <th style="width: 30%;">{{ 'product-master.description' | translate }}</th>
                            <th style="width: 15%;">{{ 'product-master.group' | translate }}</th>
                            <th style="width: 10%;text-align: center;">{{ 'product-master.code' | translate }}</th>
                            <th style="width: 10%;text-align: center;">{{ 'product-master.version' | translate }}</th>
                            <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' |
                                translate }}</th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let product of productList | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">

                        <p style="width: 5%;" title="{{product.productMasterId}}">{{product.productMasterId}}</p>
                        <p style="width: 20%;" title="{{product.name}}">{{product.name}}</p>
                        <div style="width: 30%; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; max-height: 24px; line-height: 24px;" [innerHTML]="product.description"></div>
                        <p style="width: 15%;" title="{{product.group}}">{{product.group}}</p>
                        <p style="width: 10%;text-align: center;" title="{{product.code}}">{{product.code}}</p>
                        <p style="width: 10%;text-align: center;" title="{{product.version}}">{{product.version}}</p>
                        <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                            <i *ngIf="actionControls.isModify" class="bi bi-pencil-square"
                                (click)="getProductById1(product.productMasterId)" data-toggle="modal"
                                data-target="#editModal"></i>
                            <i *ngIf="actionControls.isView" (click)="getProductById(product.productMasterId)"
                                data-toggle="modal" data-target="#productView" class="bi bi-eye-fill"></i>
                            <i *ngIf="actionControls.isDelete" (click)="selectDelete(product.id,product)"
                                data-toggle="modal" data-target="#deleteModal" class="bi bi-trash3"></i>
                        </p>
                    </div>
                </div>


                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>

                <div class="loader" *ngIf="!isLoading && productList.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>

                </div>

                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                        [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                        currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
                </div>


            </div>

        </div>
    </div>
</div>


<div class="modal fade" id="productView" tabindex="-1" role="dialog" aria-labelledby="productView" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ 'product-master.headings.detail' | translate }}
                <span data-dismiss="modal">
                    <i class="bi bi-x-lg"></i>
                </span>
            </h5>
        </div>

        <div class="modal-content">
            <div class="product-block" *ngFor="let data of singleProductData">
                <div class="product-content">
                    <div class="product-details">
                        <div class="row product-form-details">
                            <div class="col-md-6 col-lg-6 product-form">
                                <label for="">{{ 'product-master.name' | translate }}</label>
                                <p title="{{data.name}}">{{data.name || " -- "}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6 product-form">
                                <label for="">{{ 'product-master.group' | translate }}</label>
                                <p title="{{data.group}}">{{data.group || " -- "}}</p>
                            </div>
                            <div class="col-md-6 col-lg-6 product-form">
                                <label for="">{{ 'product-master.code' | translate }}</label>
                                <p>{{data.code || " -- "}}</p>
                            </div>

                            <div class="col-md-6 col-lg-6 product-form">
                                <label for="">{{ 'product-master.sku' | translate }}</label>
                                <p>{{data.sku || " -- "}}</p>
                            </div>

                            <div class="col-md-6 col-lg-6 product-form">
                                <label for="">{{ 'product-master.createdDate' | translate }}</label>
                                <p>{{data.createdDate | date}}</p>
                            </div>

                            <div class="col-md-6 col-lg-6 product-form">
                                <label for="">{{ 'product-master.description' | translate }}</label>
                                <div [innerHTML]="data.description"></div>
                            </div>

                            <!-- <div class="col-md-6 col-lg-6 product-form" *ngIf="data.warranty">
                        <label for="">Purchase Date</label>
                        <p>{{data.warrantyInfo.purchaseDate | date}}</p>
                    </div>

                    <div class="col-md-3 col-lg-3 product-form" *ngIf="data.warranty">
                        <label for="">Expiration Date</label>
                        <p>{{data.warrantyInfo.expirationDate | date}}</p>
                    </div> -->


                        </div>

                        <p class="product-title" *ngIf="data.imageUrlList.length != 0">{{ 'product-master.imageUrlList'
                            | translate }} :</p>
                        <div class="product-image-list" *ngIf="data.imageUrlList.length != 0">
                            <div class="image-list" *ngFor="let imageUrlList of data.imageUrlList;let i = index">
                                <img src="{{imageUrlList}}" alt="">
                            </div>
                        </div>

                        <p class="product-title" *ngIf="data.productSpecifications.length != 0">{{
                            'product-master.productSpecifications' | translate }} :</p>
                        <div class="product-specifications" *ngIf="data.productSpecifications.length != 0">
                            <table class="table table-striped">
                                <!-- <thead>
                          <tr>
                            <th scope="col">Key</th>
                            <th scope="col">Value</th>
                          </tr>
                        </thead> -->
                                <tbody>
                                    <tr *ngFor="let specification of data.productSpecifications;let i = index">
                                        <th scope="col">{{specification.key}}</th>
                                        <th scope="col">{{specification.value}}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>


                        <p class="product-title" *ngIf="data.warranty && data.warrantyInfo.keyValues.length != 0">{{
                            'product-master.warrantyInfo' | translate }} :</p>
                        <div class="product-specifications"
                            *ngIf="data.warranty && data.warrantyInfo.keyValues.length != 0">
                            <table class="table">
                                <tbody>
                                    <tr *ngFor="let keyValues of data.warrantyInfo.keyValues;let i = index">
                                        <th scope="col">{{keyValues.key}}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p class="product-title" *ngIf="data.supportedUOM.length != 0">{{ 'product-master.supportedUOM'
                            | translate }} :</p>
                        <div class="product-supported-uom" *ngIf="data.supportedUOM.length != 0">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ 'product-master.uomId' | translate }} </th>
                                        <th scope="col">{{ 'product-master.uomName' | translate }} </th>
                                        <th scope="col">{{ 'product-master.color' | translate }} </th>
                                        <th scope="col">{{ 'product-master.quantity' | translate }} </th>
                                        <th scope="col">{{ 'product-master.price' | translate }} </th>
                                        <th scope="col">{{ 'product-master.discountedPrice' | translate }} </th>
                                        <th scope="col">{{ 'product-master.isDefault' | translate }} </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let uom of data.supportedUOM;let i = index">
                                        <th scope="col">{{uom.uomId}}</th>
                                        <th scope="col">{{uom.uomName}}</th>
                                        <th scope="col">{{uom.color}}</th>
                                        <th scope="col">{{uom.quantity}}</th>
                                        <th scope="col">{{uom.price}}</th>
                                        <th scope="col">{{uom.discountedPrice}}</th>
                                        <th scope="col">{{uom.isDefault}}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>


                        <p class="product-title" *ngIf="data.vendorMasters.length != 0">{{
                            'product-master.vendorMasters' | translate }} :</p>
                        <div class="product-supported-uom" *ngIf="data.vendorMasters.length != 0">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ 'product-master.name' | translate }}</th>
                                        <th scope="col">{{ 'product-master.code' | translate }}</th>
                                        <th scope="col">{{ 'product-master.description' | translate }}</th>
                                        <th scope="col">{{ 'product-master.isActive' | translate }}</th>
                                        <th scope="col">{{ 'product-master.status' | translate }}</th>
                                        <th scope="col">{{ 'product-master.version' | translate }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let vendor of data.vendorMasters;let i = index">
                                        <th scope="col">{{vendor.name}}</th>
                                        <th scope="col">{{vendor.code}}</th>
                                        <th scope="col">{{vendor.description}}</th>
                                        <th scope="col">{{isActive(vendor.isActive)}}</th>
                                        <th scope="col">{{vendor.status}}</th>
                                        <th scope="col">{{vendor.version}}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>


                        <p class="product-title" *ngIf="data.keyValueList.length != 0">{{ 'product-master.keyValueList'
                            | translate }} :</p>
                        <div class="product-key-value-list" *ngIf="data.keyValueList.length != 0">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ 'product-master.key' | translate }}</th>
                                        <th scope="col">{{ 'product-master.keyValue' | translate }}</th>
                                        <th scope="col">{{ 'product-master.value' | translate }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let keyValueList of data.keyValueList;let i = index">
                                        <th scope="col">{{keyValueList.key}}</th>
                                        <th scope="col">{{keyValueList.keyValue}}</th>
                                        <th scope="col">{{keyValueList.value}}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p class="product-title" *ngIf="data.relatedProductList.length != 0">{{
                            'product-master.relatedProductList' | translate }} :</p>
                        <div class="product-related-list row" *ngIf="data.relatedProductList.length != 0">
                            <div class="product-related-list-item col-md-2 col-lg-2"
                                *ngFor="let relatedProductList of data.relatedProductList">
                                <img src="{{relatedProductList.imageUrl}}" alt="">
                                <p class="" title="{{relatedProductList.name}}">{{relatedProductList.name}}</p>
                            </div>
                        </div>


                        <p class="product-title" *ngIf="data.similarProductList.length != 0">{{
                            'product-master.similarProductList' | translate }} :</p>
                        <div class="product-related-list row" *ngIf="data.similarProductList.length != 0">
                            <div class="product-related-list-item col-md-2 col-lg-2"
                                *ngFor="let similarProductList of data.similarProductList">
                                <img src="{{similarProductList.imageUrl}}" alt="">
                                <p class="" title="{{similarProductList.name}}">{{similarProductList.name}}</p>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton" (click)="cancelModel()" class="btn btn-secondary"
                        data-dismiss="modal" class="btn btn-secondary">{{ 'generic.cancel' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closeModal()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}} (ID:
                        {{recordId}})”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="deleteModalButton1" (click)="closeModal()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleleProduct()" class="btn btn-primary">{{ 'generic.delete' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'product-master.headings.add' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="resetForm()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div class="row" [formGroup]="form">
                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <label>{{ 'product-master.name' | translate }}</label>
                            <input formControlName="name" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <label>{{ 'product-master.description' | translate }}</label>
                            <!-- <input formControlName="description" type="text" class="form-control"> -->
                            <!-- <ckeditor [(ngModel)]="description" [ngModelOptions]="{standalone: true}"></ckeditor> -->
                            <ckeditor [editor]="Editor" [config]="editorConfig" formControlName="description">
                            </ckeditor>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'product-master.group' | translate }}</label>
                            <select name="" id="" formControlName="group" class="form-control">
                                <option value="" selected disabled> -- select group -- </option>
                                <option [value]="list.name" *ngFor="let list of productGroupList">{{list.name}}</option>
                            </select>
                        </div>
                    </div>


                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'product-master.code' | translate }}</label>
                            <input formControlName="code" type="number" class="form-control">
                        </div>
                    </div>


                    <!-- <div class="form-group ">
            <label>Select UOMs</label>
            <ng-multiselect-dropdown
            [placeholder]="'select uoms'"
            [settings]="uomDropdownSettings"
            [data]="uomDropdownList"
            [(ngModel)]="uomSelectedList"
            class="form-control"
            style="padding: 0;border: none"
            [ngModelOptions]="{standalone: true}"
            (onSelect)="onItemSelect($event)"
            (onSelectAll)="onSelectAll($event)"
            >
            </ng-multiselect-dropdown>
          </div> -->

                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <div class="row">
                                <div class="items-b col-md-12 col-lg-12"
                                    *ngFor="let item of uomSelectedList1;let i = index;let first = first;let last = last;">
                                    <div class="example-box">
                                        <div class="row input-data">
                                            <div class="col-md-4 col-lg-4">
                                                <label for="">{{ 'product-master.uomName' | translate }} :</label>
                                                <select class="form-control" (change)="uomChange($event,i)"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.uomId">
                                                    <option value="" disabled selected hidden>-- select uom --</option>
                                                    <option *ngFor="let uom of uomData" [value]="uom.uomMasterId">
                                                        {{uom.uomName}}</option>
                                                </select>
                                            </div>
                                            <div class="col-md-4 col-lg-4">
                                                <label for="">{{ 'product-master.color' | translate }} :</label>
                                                <input type="text" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="item.color" class="form-control">
                                            </div>
                                            <div class="col-md-4 col-lg-4">
                                                <label for="">{{ 'product-master.currencyType' | translate }} :</label>
                                                <select name="" id="" [ngModelOptions]="{standalone: true}"
                                                    (change)="currencyChanged(item.currencyType,i)"
                                                    [(ngModel)]="item.currencyType" class="form-control">
                                                    <option [value]="currency.currencyName"
                                                        *ngFor="let currency of currencyType">{{currency.currencyName}}
                                                        - {{currency.currencySymbol}}</option>
                                                </select>
                                            </div>
                                            <div class="col-md-4 col-lg-4">
                                                <label for="">{{ 'product-master.quantity' | translate }} :</label>
                                                <input type="number" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="item.quantity" class="form-control">
                                            </div>
                                            <div class="col-md-4 col-lg-4">
                                                <label for="">{{ 'product-master.price' | translate }} :</label>
                                                <input type="number" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="item.price" class="form-control">
                                            </div>
                                            <div class="col-md-4 col-lg-4">
                                                <label for="">{{ 'product-master.discountedPrice' | translate }}
                                                    :</label>
                                                <input type="number" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="item.discountedPrice" class="form-control">
                                            </div>
                                            <div class="col-md-3 col-lg-3">
                                                <label for="">{{ 'product-master.minOrderQuantity' | translate }}
                                                    :</label>
                                                <input type="number" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="item.minOrderQuantity" class="form-control">
                                            </div>
                                            <div class="col-md-3 col-lg-3">
                                                <label for="">{{ 'product-master.maxOrderQuantity' | translate }}
                                                    :</label>
                                                <input type="number" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="item.maxOrderQuantity" class="form-control">
                                            </div>
                                            <div class="col-md-3 col-lg-3">
                                                <label for="">{{ 'product-master.distributorPrice' | translate }}
                                                    :</label>
                                                <input type="number" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="item.distributorPrice" class="form-control">
                                            </div>
                                            <div class="col-md-3 col-lg-3">
                                                <label for="">{{ 'product-master.dealerPrice' | translate }} :</label>
                                                <input type="number" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="item.dealerPrice" class="form-control">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="add-remove-button" *ngIf="!last">
                                        <button (click)="removeUOM(i)">{{ 'generic.remove' | translate }}</button>
                                    </div>
                                    <div class="add-remove-button" *ngIf="last">
                                        <button (click)="removeUOM(i)" *ngIf="i!=0">{{ 'generic.remove' | translate
                                            }}</button>
                                        <button (click)="addUOM()">{{ 'generic.add' | translate }}</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-6 col-lg-6">
                        <div class="form-group" *ngIf="isDefaultUom">
                            <label>{{ 'product-master.isDefaultUom' | translate }}</label>
                            <select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="isDefault">
                                <option value="" disabled selected hidden>-- select default uom --</option>
                                <option *ngFor="let uom of uomSelectedList1" [value]="uom.uomName">{{uom.uomName}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'product-master.version' | translate }}</label>
                            <select formControlName="version" class="form-control" name="" id="">
                                <option value="1">version 1 (Without Make and Model)</option>
                                <option value="2">version 2 (With Make and Model)</option>
                            </select>
                        </div>
                    </div>


                    <div class="col-md-12 col-lg-12">
                        <div class="form-group" *ngFor="let list of keyValueList">
                            <label>{{list.key}}</label>
                            <input type="text" class="form-control" *ngIf="list.possibleValue.length == 0"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                            <select class="form-control" *ngIf="list.possibleValue.length != 0"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                                <option *ngFor="let possibleValue of list.possibleValue" [value]="possibleValue">
                                    {{possibleValue}}</option>
                            </select>
                        </div>
                    </div>


                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <label>{{ 'product-master.productSpecifications' | translate }}</label>
                            <div class="specifications-block">
                                <div class="specifications-data"
                                    *ngFor="let specification of productSpecifications;let i = index;let first = first;let last = last;">
                                    <input [ngModelOptions]="{standalone: true}" type="text" class=""
                                        placeholder="enter key" [(ngModel)]="specification.key">
                                    <textarea [ngModelOptions]="{standalone: true}" name="" id="" cols="30" class=""
                                        placeholder="enter value" [(ngModel)]="specification.value"
                                        rows="10"></textarea>
                                    <span><i class="bi bi-plus-circle" (click)="addProductSpecifications()"></i><i
                                            class="bi bi-dash-circle" *ngIf="!first && i != 0"
                                            (click)="removeProductSpecifications(i)"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>





                    <div class="col-md-12 col-lg-12">
                        <div class="">
                            <div class="form-group image-b" *ngIf="form.controls['image'].value == ''">
                                <label>{{ 'product-master.imageUrl' | translate }} </label>
                                <button class="" (click)="imageButtonClick()">{{ 'generic.add' | translate }}</button>
                                <input type="file" id="imageInput" (change)="onChange($event)" accept="image/*"
                                    [style.display]="'none'">
                            </div>
                            <div class="form-group image-view" *ngIf="form.controls['image'].value != ''">
                                <label>{{ 'product-master.imageUrl' | translate }} </label>
                                <img [src]="form.controls['image'].value" alt="" srcset="">
                                <button class="btn btn-secondary" (click)="imageRemove()">{{ 'generic.remove' |
                                    translate }}</button>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-12 col-lg-12">
                        <div class="">
                            <div class="form-group image-b">
                                <label>{{ 'product-master.imageUrlList' | translate }}</label>
                                <button class="" (click)="imageListButtonClick()">{{ 'generic.add' | translate
                                    }}</button>
                                <input type="file" id="imageListInput" (change)="onListChange($event)" accept="image/*"
                                    [style.display]="'none'">
                            </div>
                            <div class="form-group image-view-list row" *ngIf="imageUrlList.length != 0">
                                <div class="col-md-2 col-lg-2" *ngFor="let image of imageUrlList;let i = index">
                                    <img [src]="image" alt="" srcset="">
                                    <i class="bi bi-x-lg" (click)="imageListRemove(i)"></i>
                                </div>
                            </div>
                        </div>
                    </div>





                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <label>{{ 'product-master.relatedProductList' | translate }}</label>
                            <ng-multiselect-dropdown [placeholder]="'select related products'"
                                [settings]="relatedProductDropdownSettings" [data]="relatedProductDropdownList"
                                [(ngModel)]="relatedProductSelectedList" class="form-control"
                                [ngModelOptions]="{standalone: true}" style="padding: 0;border: none"
                                (onSelect)="onRelatedProductSelect($event)" (onDeSelect)="onDeSelect($event)">
                            </ng-multiselect-dropdown>
                        </div>
                    </div>


                    <div class="form-group product-view-list row" *ngIf="relatedProductList.length != 0">
                        <div class="col-md-2 col-lg-2" *ngFor="let product of relatedProductList;let i = index">
                            <div class="product-view-detail">
                                <img [src]="product.imageUrl" alt="" srcset="">
                                <p>{{ product.name }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <label>{{ 'product-master.similarProductList' | translate }}</label>
                            <ng-multiselect-dropdown [placeholder]="'select similar products'"
                                [settings]="similarProductDropdownSettings" [data]="similarProductDropdownList"
                                [(ngModel)]="similarProductSelectedList" class="form-control"
                                [ngModelOptions]="{standalone: true}" style="padding: 0;border: none"
                                (onSelect)="onSimilarProductSelect($event)" (onDeSelect)="onDeSelectSimilar($event)">
                            </ng-multiselect-dropdown>
                        </div>
                    </div>


                    <div class="form-group product-view-list row" *ngIf="similarProductList.length != 0">
                        <div class="col-md-2 col-lg-2" *ngFor="let product of similarProductList;let i = index">
                            <div class="product-view-detail">
                                <img [src]="product.imageUrl" alt="" srcset="">
                                <p>{{ product.name }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <label>{{ 'product-master.taxInfoList' | translate }} </label>
                            <ng-multiselect-dropdown [placeholder]="'select tax info'"
                                [settings]="taxInfoDropdownSettings" [data]="taxInfoDropdownList"
                                [(ngModel)]="taxInfoSelectedList" class="form-control"
                                [ngModelOptions]="{standalone: true}" style="padding: 0;border: none"
                                (onSelect)="onTaxInfoSelect($event)" (onDeSelect)="onDeSelectTaxMaster($event)">
                            </ng-multiselect-dropdown>
                        </div>
                    </div>



                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'product-master.vendorMasters' | translate }}</label>
                            <ng-multiselect-dropdown [placeholder]="'select vendors'"
                                [settings]="vendorMastersDropdownSettings" [data]="vendorMastersDropdownList"
                                [(ngModel)]="vendorMastersSelectedList" class="form-control"
                                [ngModelOptions]="{standalone: true}" style="padding: 0;border: none"
                                (onSelect)="vendorSelect($event)" (onDeSelect)="onDeSelectVendor($event)">
                            </ng-multiselect-dropdown>
                        </div>
                    </div>


                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'product-master.sku' | translate }}</label>
                            <input formControlName="sku" type="text" class="form-control">
                        </div>
                    </div>


                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <label for="">{{ 'product-master.productSaleType' | translate }}</label>
                            <div class="productSaleType-list">
                                <div *ngFor="let type of productSaleTypeList;let i = index">
                                    <input type="checkbox" [(ngModel)]="type.isChecked"
                                        [ngModelOptions]="{standalone: true}">
                                    <label for="">{{type.type}}</label>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <label>{{ 'product-master.tags' | translate }}</label>
                            <div class="tags-block">
                                <div class="tags-data"
                                    *ngFor="let tag of tags;let i = index;let first = first;let last = last;">
                                    <input [ngModelOptions]="{standalone: true}" type="text" class=""
                                        placeholder="Enter Tag" [(ngModel)]="tag.key">
                                    <span><i class="bi bi-plus-circle" (click)="addTags()"></i><i
                                            class="bi bi-dash-circle" *ngIf="!first && i != 0"
                                            (click)="removeTags(i)"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <div class="productSaleType-list">
                                <div>
                                    <input type="checkbox" formControlName="warranty">
                                    <label for="">{{ 'product-master.warranty' | translate }}</label>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-12 col-lg-12">
                        <div class="row" *ngIf="form.controls['warranty'].value == true">

                            <div class="col-lg-3 col-md-3">
                                <div class="form-group date-check">
                                    <input disabled checked type="checkbox">
                                    <label>{{ 'product-master.purchaseDate' | translate }}</label>
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-3">
                                <div class="form-group date-check">
                                    <input disabled checked type="checkbox">
                                    <label>{{ 'product-master.expirationDate' | translate }}</label>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="col-md-12 col-lg-12">
                        <div class="form-group" *ngIf="form.controls['warranty'].value == true">
                            <label>{{ 'product-master.warrantyInfo' | translate }}</label>
                            <div class="tags-block">
                                <div class="tags-data"
                                    *ngFor="let key of warrantyInfoKeyValues;let i = index;let first = first;let last = last;">
                                    <input [ngModelOptions]="{standalone: true}" type="text" class=""
                                        placeholder="Enter Key" [(ngModel)]="key.key">
                                    <span><i class="bi bi-plus-circle" (click)="addWarrantyInfoKeyValues()"></i><i
                                            class="bi bi-dash-circle" *ngIf="!first && i != 0"
                                            (click)="removeWarrantyInfoKeyValues(i)"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

            </div>
            <div class="modal-footer">
                <button type="button" id="closeModalButton3" (click)="resetForm()" class="btn btn-secondary"
                    data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                <button type="button" (click)="addProduct()" class="btn btn-primary">{{ 'generic.add' | translate
                    }}</button>
            </div>
        </div>
    </div>
</div>




<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'product-master.headings.edit' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="form">
                    <div class="form-group">
                        <label>{{ 'product-master.name' | translate }}</label>
                        <input formControlName="name" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>{{ 'product-master.description' | translate }}</label>
                        <input formControlName="description" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>{{ 'product-master.group' | translate }}</label>
                        <input formControlName="group" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>{{ 'product-master.code' | translate }}</label>
                        <input formControlName="code" type="number" class="form-control">
                    </div>
                    <div class="form-group ">
                        <label>{{ 'product-master.supportedUOM' | translate }}</label>
                        <ng-multiselect-dropdown [placeholder]="'select uoms'" [settings]="uomDropdownSettings"
                            [data]="uomDropdownList" [(ngModel)]="uomSelectedList" class="form-control"
                            style="padding: 0;border: none" [ngModelOptions]="{standalone: true}"
                            (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)"
                            (onSelectAll)="onSelectAll($event)">
                        </ng-multiselect-dropdown>
                    </div>

                    <div class="form-group">
                        <div class=" row">
                            <div class="items-b col-md-6 col-lg-6" *ngFor="let item of uomSelectedList1;let i = index">
                                <div class="example-box">
                                    <div class="row input-data">
                                        <div class="col-md-4 col-lg-4">
                                            <label for="">{{ 'product-master.uomName' | translate }} :</label>
                                            <input type="text" [ngModelOptions]="{standalone: true}" readonly
                                                [(ngModel)]="item.uomName" class="form-control">
                                        </div>
                                        <div class="col-md-4 col-lg-4">
                                            <label for="">{{ 'product-master.color' | translate }} :</label>
                                            <input type="text" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="item.color" class="form-control">
                                        </div>
                                        <div class="col-md-4 col-lg-4">
                                            <label for="">{{ 'product-master.currencyType' | translate }} :</label>
                                            <select name="" id="" [ngModelOptions]="{standalone: true}"
                                                (change)="currencyChanged(item.currencyType,i)"
                                                [(ngModel)]="item.currencyType" class="form-control">
                                                <option [value]="currency.currencyName"
                                                    *ngFor="let currency of currencyType">{{currency.currencyName}} -
                                                    {{currency.currencySymbol}}</option>
                                            </select>
                                        </div>
                                        <div class="col-md-4 col-lg-4">
                                            <label for="">{{ 'product-master.quantity' | translate }} :</label>
                                            <input type="number" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="item.quantity" class="form-control">
                                        </div>
                                        <div class="col-md-4 col-lg-4">
                                            <label for="">{{ 'product-master.price' | translate }} :</label>
                                            <input type="number" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="item.price" class="form-control">
                                        </div>
                                        <div class="col-md-4 col-lg-4">
                                            <label for="">{{ 'product-master.discountedPrice' | translate }} :</label>
                                            <input type="number" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="item.discountedPrice" class="form-control">
                                        </div>
                                        <div class="col-md-4 col-lg-4">
                                            <label for="">{{ 'product-master.minOrderQuantity' | translate }} :</label>
                                            <input type="number" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="item.minOrderQuantity" class="form-control">
                                        </div>
                                        <div class="col-md-4 col-lg-4">
                                            <label for="">{{ 'product-master.maxOrderQuantity' | translate }} :</label>
                                            <input type="number" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="item.maxOrderQuantity" class="form-control">
                                        </div>
                                        <div class="col-md-4 col-lg-4">
                                            <label for="">{{ 'product-master.distributorPrice' | translate }} :</label>
                                            <input type="number" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="item.distributorPrice" class="form-control">
                                        </div>
                                        <div class="col-md-4 col-lg-4">
                                            <label for="">{{ 'product-master.dealerPrice' | translate }} :</label>
                                            <input type="number" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="item.dealerPrice" class="form-control">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>{{ 'product-master.isDefaultUom' | translate }}</label>
                        <select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="isDefault">
                            <option value="" disabled selected hidden>-- select default uom --</option>
                            <option *ngFor="let uom of uomSelectedList" [value]="uom.uomMasterId">{{uom.uomName}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group" *ngFor="let list of keyValueList">
                        <label>{{list.key}}</label>
                        <input type="text" class="form-control" *ngIf="list.possibleValue.length == 0"
                            [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                        <select class="form-control" *ngIf="list.possibleValue.length != 0"
                            [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                            <option *ngFor="let possibleValue of list.possibleValue" [value]="possibleValue">
                                {{possibleValue}}</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>{{ 'product-master.productSpecifications' | translate }}</label>
                        <div class="specifications-block">
                            <div class="specifications-data"
                                *ngFor="let specification of productSpecifications;let i = index;let first = first;let last = last;">
                                <input [ngModelOptions]="{standalone: true}" type="text" class=""
                                    placeholder="enter key" [(ngModel)]="specification.key">
                                <textarea [ngModelOptions]="{standalone: true}" name="" id="" cols="30" class=""
                                    placeholder="enter value" [(ngModel)]="specification.value" rows="10"></textarea>
                                <span><i class="bi bi-plus-circle" (click)="addProductSpecifications()"></i><i
                                        class="bi bi-dash-circle" *ngIf="!first && i != 0"
                                        (click)="removeProductSpecifications(i)"></i></span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>{{ 'product-master.version' | translate }}</label>
                        <select formControlName="version" class="form-control" name="" id="">
                            <option value="1">version 1 (Without Make and Model)</option>
                            <option value="2">version 2 (With Make and Model)</option>
                        </select>
                    </div>

                    <div class="">
                        <div class="form-group image-b" *ngIf="form.controls['image'].value == ''">
                            <label>{{ 'product-master.imageUrl' | translate }} </label>
                            <button class="" (click)="imageButtonClick()">Add Image</button>
                            <input type="file" id="imageInput" (change)="onChange($event)" accept="image/*"
                                [style.display]="'none'">
                        </div>
                        <div class="form-group image-view" *ngIf="form.controls['image'].value != ''">
                            <label>{{ 'product-master.imageUrl' | translate }} </label>
                            <img [src]="form.controls['image'].value" alt="" srcset="">
                            <button class="btn btn-secondary" (click)="imageRemove()">Remove</button>
                        </div>
                    </div>

                    <div class="">
                        <div class="form-group image-b">
                            <label>{{ 'product-master.imageUrlList' | translate }}</label>
                            <button class="" (click)="imageListButtonClick()">Add Image</button>
                            <input type="file" id="imageListInput" (change)="onListChange($event)" accept="image/*"
                                [style.display]="'none'">
                        </div>
                        <div class="form-group image-view-list row" *ngIf="imageUrlList.length != 0">
                            <div class="col-md-2 col-lg-2" *ngFor="let image of imageUrlList;let i = index">
                                <img [src]="image" alt="" srcset="">
                                <i class="bi bi-x-lg" (click)="imageListRemove(i)"></i>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>{{ 'product-master.vendorMasters' | translate }}</label>
                        <ng-multiselect-dropdown [placeholder]="'select vendors'"
                            [settings]="vendorMastersDropdownSettings" [data]="vendorMastersDropdownList"
                            [(ngModel)]="vendorMastersSelectedList" class="form-control"
                            [ngModelOptions]="{standalone: true}" style="padding: 0;border: none"
                            (onSelect)="vendorSelect($event)" (onDeSelect)="onDeSelectVendor($event)">
                        </ng-multiselect-dropdown>
                    </div>

                    <div class="form-group">
                        <label>{{ 'product-master.relatedProductList' | translate }}</label>
                        <ng-multiselect-dropdown [placeholder]="'select related products'"
                            [settings]="relatedProductDropdownSettings" [data]="relatedProductDropdownList"
                            [(ngModel)]="relatedProductSelectedList" class="form-control"
                            [ngModelOptions]="{standalone: true}" style="padding: 0;border: none"
                            (onSelect)="onRelatedProductSelect($event)" (onDeSelect)="onDeSelect($event)">
                        </ng-multiselect-dropdown>
                    </div>
                    <div class="form-group product-view-list row" *ngIf="relatedProductList.length != 0">
                        <div class="col-md-2 col-lg-2" *ngFor="let product of relatedProductList;let i = index">
                            <div class="product-view-detail">
                                <img [src]="product.imageUrl" alt="" srcset="">
                                <p>{{ product.name }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>{{ 'product-master.similarProductList' | translate }}</label>
                        <ng-multiselect-dropdown [placeholder]="'select similar products'"
                            [settings]="similarProductDropdownSettings" [data]="similarProductDropdownList"
                            [(ngModel)]="similarProductSelectedList" class="form-control"
                            [ngModelOptions]="{standalone: true}" style="padding: 0;border: none"
                            (onSelect)="onSimilarProductSelect($event)" (onDeSelect)="onDeSelectSimilar($event)">
                        </ng-multiselect-dropdown>
                    </div>
                    <div class="form-group product-view-list row" *ngIf="similarProductList.length != 0">
                        <div class="col-md-2 col-lg-2" *ngFor="let product of similarProductList;let i = index">
                            <div class="product-view-detail">
                                <img [src]="product.imageUrl" alt="" srcset="">
                                <p>{{ product.name }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>{{ 'product-master.taxInfoList' | translate }} </label>
                        <ng-multiselect-dropdown [placeholder]="'select tax info'" [settings]="taxInfoDropdownSettings"
                            [data]="taxInfoDropdownList" [(ngModel)]="taxInfoSelectedList" class="form-control"
                            [ngModelOptions]="{standalone: true}" style="padding: 0;border: none"
                            (onSelect)="onTaxInfoSelect($event)" (onDeSelect)="onDeSelectTaxMaster($event)">
                        </ng-multiselect-dropdown>
                    </div>

                    <div class="form-group">
                        <label>{{ 'product-master.sku' | translate }}</label>
                        <input formControlName="sku" type="text" class="form-control">
                    </div>

                    <div class="form-group">
                        <label for="">{{ 'product-master.productSaleType' | translate }}</label>
                        <div class="productSaleType-list">
                            <div *ngFor="let type of productSaleTypeList;let i = index">
                                <input type="checkbox" [(ngModel)]="type.isChecked"
                                    [ngModelOptions]="{standalone: true}">
                                <label for="">{{type.type}}</label>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>{{ 'product-master.tags' | translate }}</label>
                        <div class="tags-block">
                            <div class="tags-data"
                                *ngFor="let tag of tags;let i = index;let first = first;let last = last;">
                                <input [ngModelOptions]="{standalone: true}" type="text" class=""
                                    placeholder="enter tag" [(ngModel)]="tag.key">
                                <span><i class="bi bi-plus-circle" (click)="addTags()"></i><i class="bi bi-dash-circle"
                                        *ngIf="!first && i != 0" (click)="removeTags(i)"></i></span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="productSaleType-list">
                            <div>
                                <input type="checkbox" formControlName="warranty">
                                <label for="">{{ 'product-master.warranty' | translate }}</label>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="form.controls['warranty'].value == true">

                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <label>{{ 'product-master.purchaseDate' | translate }}</label>
                                <input formControlName="purchaseDate" type="date" class="form-control">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <label>{{ 'product-master.expirationDate' | translate }}</label>
                                <input formControlName="expirationDate" type="date" class="form-control">
                            </div>
                        </div>

                    </div>

                    <div class="form-group" *ngIf="form.controls['warranty'].value == true">
                        <label>{{ 'product-master.warrantyInfo' | translate }}</label>
                        <div class="tags-block">
                            <div class="tags-data"
                                *ngFor="let key of warrantyInfoKeyValues;let i = index;let first = first;let last = last;">
                                <input [ngModelOptions]="{standalone: true}" type="text" class=""
                                    placeholder="Enter Key" [(ngModel)]="key.key">
                                <span><i class="bi bi-plus-circle" (click)="addWarrantyInfoKeyValues()"></i><i
                                        class="bi bi-dash-circle" *ngIf="!first && i != 0"
                                        (click)="removeWarrantyInfoKeyValues(i)"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="closeModalButton4" data-dismiss="modal" class="btn btn-secondary">{{
                    'generic.cancel' | translate }}</button>
                <button type="button" (click)="updateProduct()" class="btn btn-primary">{{ 'generic.update' | translate
                    }}</button>
            </div>
        </div>
    </div>
</div>